import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useInView } from '@/hooks/useInView';

export const AboutSection = ({ t }) => {
  const [ref, isInView] = useInView();

  return (
    <section id="about" className="py-20 bg-gray-50" data-testid="about-section">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-testid="about-title">{t.about.title}</h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-testid="about-subtitle">{t.about.subtitle}</h3>
            <p className="text-gray-700 mb-6 leading-relaxed" data-testid="about-description-1">{t.about.description1}</p>
            <p className="text-gray-700 mb-6 leading-relaxed" data-testid="about-description-2">{t.about.description2}</p>
            <p className="text-gray-700 leading-relaxed" data-testid="about-description-3">{t.about.description3}</p>
          </div>

          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h4 className="text-xl font-bold text-gray-900 mb-6" data-testid="about-values-title">{t.about.valuesTitle}</h4>
            <div className="space-y-4">
              {[
                { key: 'efficiency', label: t.about.efficiency, desc: t.about.efficiencyDesc },
                { key: 'safety', label: t.about.safety, desc: t.about.safetyDesc },
                { key: 'continuity', label: t.about.continuity, desc: t.about.continuityDesc },
                { key: 'reliability', label: t.about.reliability, desc: t.about.reliabilityDesc },
              ].map((value) => (
                <div key={value.key} className="flex items-start" data-testid={`value-${value.key}`}>
                  <CheckCircle2 className="text-blue-600 mr-3 mt-1 flex-shrink-0" size={20} />
                  <div>
                    <h5 className="font-semibold text-gray-900">{value.label}</h5>
                    <p className="text-gray-600 text-sm">{value.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
